<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_12"></a><a id="ch1"></a>CHAPTER 1</h2>
<h2 class="h2a">BREAKING IT DOWN</h2>
<h2 class="h2b">Candy-Bar Elements, Ingredients, and Tools</h2>
<p class="tocx"><a href="#/xhtml/chapter01a#ch1lev1"><span class="brown"><span class="strong1">What Is a Candy Bar—and What Should Be in It?</span></span></a></p>
<p class="tocx"><a href="#/xhtml/chapter01b#ch1lev2"><span class="brown"><span class="strong1">The Sweet Life: Then and Now</span></span></a></p>
<p class="tocx"><span href="#/xhtml/chapter01c#ch1lev3" title="Link target outside of Sample"><span class="brown"><span class="strong1">The Artisan Option</span></span></span></p>
<p class="tocx"><span href="#/xhtml/chapter01d#ch1lev4" title="Link target outside of Sample"><span class="brown"><span class="strong1">Candy-Bar Toolbox</span></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter01.vue?7f4c27aa